import React from "react";
import "./Service.css";

const Service = (props) => {
    const { name, desc, img } = props.service;
    return (
        <div className="col-md-4">
            <div className="service-card">
                <img src={img} alt="" />
                <h4>{name}</h4>
                <p>{desc}</p>
            </div>
        </div>
    );
};

export default Service;
